import { SurrenderPhase } from '../protocol/gen/warinspace/v2/common_pb.js';
import type { SurrenderState } from '../protocol/gen/warinspace/v2/server_to_client_pb.js';

export type SurrenderPhaseName = 'locked' | 'available' | 'voting' | 'cooldown';

export interface SurrenderView {
  readonly phase: SurrenderPhaseName;
  readonly yes: number;
  readonly no: number;
  readonly needed: number;
  readonly voters: number;
  readonly secondsRemaining: number;
  readonly youVoted: boolean;
}

export function surrenderPhaseFromWire(phase: SurrenderPhase): SurrenderPhaseName {
  switch (phase) {
    case SurrenderPhase.AVAILABLE:
      return 'available';
    case SurrenderPhase.VOTING:
      return 'voting';
    case SurrenderPhase.COOLDOWN:
      return 'cooldown';
    case SurrenderPhase.LOCKED:
    case SurrenderPhase.UNSPECIFIED:
      return 'locked';
  }
}

export function surrenderViewFrom(state: SurrenderState): SurrenderView {
  return {
    phase: surrenderPhaseFromWire(state.phase),
    yes: state.yes,
    no: state.no,
    needed: state.needed,
    voters: state.voters,
    secondsRemaining: state.secondsRemaining,
    youVoted: state.youVoted,
  };
}

export function surrenderCountdown(seconds: number): string {
  const whole = Math.max(0, Math.floor(seconds));
  const minutes = Math.floor(whole / 60);
  return `${String(minutes)}:${String(whole % 60).padStart(2, '0')}`;
}

export function surrenderHeadline(view: SurrenderView): string {
  switch (view.phase) {
    case 'voting':
      return `Surrender? ${String(view.yes)}/${String(view.needed)}`;
    case 'cooldown':
      return `Vote again in ${surrenderCountdown(view.secondsRemaining)}`;
    case 'locked':
      return `Surrender in ${surrenderCountdown(view.secondsRemaining)}`;
    case 'available':
      return 'Surrender';
  }
}

/** Bots abstain, so the denominator is the humans on the team — one of them is a majority of one. */
export function surrenderDetail(view: SurrenderView): string {
  if (view.phase === 'voting') {
    return `${String(view.no)} no · ${String(view.secondsRemaining)}s`;
  }
  return `${String(view.voters)} pilot${view.voters === 1 ? '' : 's'} voting`;
}
